import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { Vue, Options } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import WIcon from "@/components/wrapper/w-icon.vue";
var WTextInput = /*#__PURE__*/function (_Vue) {
  function WTextInput() {
    var _this;
    _classCallCheck(this, WTextInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, WTextInput, [].concat(args));
    _defineProperty(_this, "type", void 0);
    _defineProperty(_this, "size", void 0);
    _defineProperty(_this, "width", void 0);
    _defineProperty(_this, "fieldLabel", void 0);
    _defineProperty(_this, "placeholder", void 0);
    _defineProperty(_this, "value", void 0);
    _defineProperty(_this, "disabled", void 0);
    _defineProperty(_this, "leftPin", void 0);
    _defineProperty(_this, "rightPin", void 0);
    _defineProperty(_this, "showPassword", void 0);
    _defineProperty(_this, "customClass", void 0);
    _defineProperty(_this, "readonly", void 0);
    _defineProperty(_this, "prefixIcon", void 0);
    _defineProperty(_this, "prefixWIcon", void 0);
    _defineProperty(_this, "suffixIcon", void 0);
    _defineProperty(_this, "currentValue", '');
    return _this;
  }
  _inherits(WTextInput, _Vue);
  return _createClass(WTextInput, [{
    key: "mounted",
    value: function mounted() {
      this.currentValue = this.value;
    }
  }, {
    key: "onInputUpdate",
    value: function onInputUpdate() {
      if (!this.disabled) {
        this.$emit('inputChanged', this.currentValue);
      }
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      if (!this.disabled) {
        this.$emit("blur", this.currentValue);
      }
    }
  }, {
    key: "onEnterPressed",
    value: function onEnterPressed() {
      if (!this.disabled) {
        this.$emit("enterPressed", this.currentValue);
      }
    }
  }]);
}(Vue);
__decorate([Prop({
  default: 'text'
})], WTextInput.prototype, "type", void 0);
__decorate([Prop({
  default: 'default'
})], WTextInput.prototype, "size", void 0);
__decorate([Prop({
  default: 'auto'
})], WTextInput.prototype, "width", void 0);
__decorate([Prop()], WTextInput.prototype, "fieldLabel", void 0);
__decorate([Prop()], WTextInput.prototype, "placeholder", void 0);
__decorate([Prop()], WTextInput.prototype, "value", void 0);
__decorate([Prop({
  default: false
})], WTextInput.prototype, "disabled", void 0);
__decorate([Prop()], WTextInput.prototype, "leftPin", void 0);
__decorate([Prop()], WTextInput.prototype, "rightPin", void 0);
__decorate([Prop()], WTextInput.prototype, "showPassword", void 0);
__decorate([Prop({
  default: ''
})], WTextInput.prototype, "customClass", void 0);
__decorate([Prop({
  default: false
})], WTextInput.prototype, "readonly", void 0);
__decorate([Prop()], WTextInput.prototype, "prefixIcon", void 0);
__decorate([Prop()], WTextInput.prototype, "prefixWIcon", void 0);
__decorate([Prop()], WTextInput.prototype, "suffixIcon", void 0);
__decorate([Watch('currentValue')], WTextInput.prototype, "onInputUpdate", null);
WTextInput = __decorate([Options({
  components: {
    WIcon: WIcon
  },
  props: {
    value: {
      type: String
    }
  },
  watch: {
    value: function value() {
      this.currentValue = this.value;
    }
  }
})], WTextInput);
export default WTextInput;